import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { CURRENT_METRIC_UPDATED } from '../query/metric'
import { Link } from 'react-router-dom'

class InvalidProbeComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: this.getInactiveVehicles(props.metrics)
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update state when latestMetrics prop changes (from polling)
    if (nextProps.metrics !== this.props.metrics) {
      this.setState({
        data: this.getInactiveVehicles(nextProps.metrics)
      })
    }
  }

  getInactiveVehicles (metrics) {
    // Get today's date at midnight (start of day)
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const inactiveVehicles = metrics.filter((metric) => {
      // Parse the occurred_at timestamp
      const occurredDate = new Date(metric.occurred_at)
      // Return true if occurred_at is before today (< today)
      return occurredDate < today
    })
    return { 'inactiveVehicles': inactiveVehicles.length, sumVehicle: this.props.sensorIds.length }
  }

  render () {
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='AUTRES VEHICULES'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.inactiveContent}>
            <span style={styles.inactiveNumber}>{this.state.data.inactiveVehicles}/{this.state.data.sumVehicle}</span>
            <p style={styles.vehicleNumber}>véhicules sans activité</p>
          </div>
          <div style={styles.contentButton}>
            <Link style={styles.link}
              to={{
                pathname: `/${localStorage.getItem('endpoint')}/all-report`,
                state: {
                  allVehicleIsChecked: true
                }
              }}
            >
              <div style={styles.button}>Liste des véhicules</div>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  inactiveContent: {
    paddingTop: '7px',
    textAlign: 'center',
    width: '100%',
    height: '40px',
    marginTop: '90px'
  },
  inactiveNumber: {
    fontSize: '30px',
    color: '#F9555E',
    fontWeight: 'bold'
  },
  vehicleNumber: {
    fontSize: '15px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  contentButton: {
    height: '48px',
    width: '100%'
  },
  link: {
    textDecoration: 'none'
  },
  button: {
    textAlign: 'center',
    paddingTop: '12px',
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '117px',
    height: '30px',
    borderRadius: '22px',
    borderColor: '#7ED321',
    borderWidth: '1px',
    borderStyle: 'solid',
    fontSize: '14px',
    fontWeight: 500,
    color: '#7ED321'
  }
}

export default InvalidProbeComponent
